import React from 'react';
import { makeStyles, Theme, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { CharacterErrorType } from 'components/ReportsModule/types';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: theme.spacing(2),
    display: 'grid',
    gridGap: `${theme.spacing(1)}px`
  }
}));

const ErrorTypeHelpInfo: React.FC = () => {
  const { t } = useTranslation('Reports');
  const classes = useStyles();

  return (
    <Typography className={classes.container} component="ul">
      <li>
        <strong>{t(CharacterErrorType.OUT_OF_BOUNDS, { ns: 'CharacterErrorType' })}</strong> -{' '}
        {t('Outside the tolerance range of the character.')}
      </li>
      <li>
        <strong>{t(CharacterErrorType.STARTED_WRONG_WAY, { ns: 'CharacterErrorType' })}</strong> -{' '}
        {t('Character is not drawn in the right direction.')}
      </li>
      <li>
        <strong>{t(CharacterErrorType.LIFTED_FINGER, { ns: 'CharacterErrorType' })}</strong> -{' '}
        {t('Finger is lifted in between drawing a character.')}
      </li>
      <li>
        <strong>{t(CharacterErrorType.REVERSED_DIRECTION, { ns: 'CharacterErrorType' })}</strong> -{' '}
        {t('Character is drawn going in the opposite direction.')}
      </li>
      <li>
        <strong>{t(CharacterErrorType.MISSED_STARTING_POINT, { ns: 'CharacterErrorType' })}</strong>{' '}
        - {t('Character is started in a place other than the correct starting point.')}
      </li>
    </Typography>
  );
};

export default ErrorTypeHelpInfo;
